const getHost = () => {
    if (window.location.hostname.indexOf('localhost') > -1) {
        return 'https://dev.gotrova.ai'
    }
    return ''
}

const appConfig = {

    serverUrlGateway: `${getHost()}/gateway`,
    // serverURL:"http://www.vertextslack.com",
    //serverURL:"http://localhost:8085",
    // addToSlackURL:"https://slack.com/oauth/v2/authorize?client_id=1585683723283.1585742003011&scope=incoming-webhook&redirect_uri=http://50.112.179.195:8080/slack_redirect&state=1"
    // channels:history,channels:read,groups:history,im:history,mpim:history,users.profile:read,users:read,groups:read,search:read
    // channels%3Ahistory%2Cchannels%3Aread%2Cgroups%3Ahistory%2Cim%3Ahistory%2Cmpim%3Ahistory%2Cusers.profile%3Aread%2Cusers%3Aread%2Cgroups%3Aread%2Csearch%3Aread
    // addToSlackURL:"https://slack.com/oauth/v2/authorize?client_id=1585683723283.1585742003011&user_scope=channels%3Ahistory%2Cchannels%3Aread%2Cgroups%3Ahistory%2Cim%3Ahistory%2Cmpim%3Ahistory%2Cusers.profile%3Aread%2Cusers%3Aread%2Cgroups%3Aread%2Csearch%3Aread&scope=incoming-webhook&redirect_uri=http://www.vertextslack.com:8085/slack_redirect&state=1"

};

export default appConfig;